import { init as initGrid } from '../../../core/js/components/gridComponent';
import { init as initGridControls } from './categoryGridControlsComponent';
import { init as rrInit } from '../../../core/js/components/richRelevanceComponent';
import { init as initProductTray } from '../../../core/js/components/productTrayComponent';

import { debug } from '../../../core/js/utils/logger';

import template from 'category-browse.j2';

import { dDom } from '../../../core/js/utils/renderUtils';
import { generate } from '../../../core/js/utils/componentUtils';

export function onStateChange(store, watchValue, oldVal, newVal) {
    /* eslint-disable no-extra-parens */
    if ((oldVal > 0 && newVal > 0) ||
        (oldVal < 0 && newVal < 0) ||
        (!oldVal && !newVal)) {
        return;
    }

    debug('Category: update browse');

    if (newVal) {
        _.forEach(this.childrenObjects, (child) => {
            this.reactivateChild(child, store);
        });
    }

    this.render(store, this, {});
}

function noProductsOrLanding(store) {
    const state = store.getState();
    const recordCount = _.get(state, 'category.products.totalRecordCount');
    const noLandingPage = _.isEmpty(_.get(state, 'category.landingPage'));
    return recordCount < 1 && noLandingPage;
}

export function init(store, overrides = {}) {
    const config = {
        children: [
            initGridControls,
            initGrid,
            [rrInit, {
                isComponentValid: noProductsOrLanding
            }],
            [initProductTray, {
                feature: 'category'
            }]
        ],
        templateLocation: '.dom-category-browse',
        watch: 'category.products.totalRecordCount',
        name: 'browseComponent',
        onStateChange: onStateChange,
        template: template,
        rebind: true,
        renderType: dDom
    };

    return generate(config, store, overrides);
}
